module.exports = __webpack_public_path__ + "static/media/img_features_04.203d5421.jpg";